<template>
  <div id="app" :class="osClassname">
    <!-- FIXME -->
    <router-view />

    <!-- 这里不能直接用a-spin包裹router-view，不然宽高会出现问题 -->
    <div v-show="loading" class="app-spin-wrapper">
      <div class="app-spin-blur" :style="{ opacity: loading ? 0.5 : 0 }" />
      <a-spin :tip="tip">
        <a-icon slot="indicator" type="loading" style="font-size: 50px" spin />
      </a-spin>
    </div>
  </div>
</template>

<script>
export default {
  provide() {
    return {
      rootChangeLoading: this.changeLoading
    }
  },
  data() {
    return {
      loading: false,
      tip: ''
    }
  },
  computed: {
    osClassname() {
      const agent = navigator.userAgent.toLowerCase()
      const isMac = /macintosh|mac os x/i.test(navigator.userAgent)
      if (agent.indexOf('win32') >= 0 || agent.indexOf('wow32') >= 0) {
        return ['is-windows-os', 'is-32-bit-sys']
      }
      if (agent.indexOf('win64') >= 0 || agent.indexOf('wow64') >= 0) {
        return ['is-windows-os', 'is-64-bit-sys']
      }
      if (isMac) {
        return ['is-mac-os']
      }

      return []
    }
  },
  created() {
    window.setLoading2root = this.changeLoading
  },
  methods: {
    changeLoading(isLoading = false, tip = '') {
      this.tip = tip
      this.loading = isLoading
    }
  }
}
</script>
<style lang="scss">
@import './assets/css/lib/common.scss';

.app-spin-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;

  .app-spin-blur {
    width: 100%;
    height: 100%;
    user-select: none;
    pointer-events: none;
    overflow: hidden;
    transition: opacity 0.3s;
    background: #fff;
  }

  .ant-spin {
    position: absolute;
    left: 55%;
    top: 40%;
    transform: translateX(-50%) translateY(-50%);
  }

  .main-container-subSidebar {
    z-index: 11;
    .subSidebar-menu {
      background-color: #235baf;
    }
  }
}
</style>
